import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-form-field-info',
  templateUrl: './form-field-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./form-field-info.component.scss']
})
export class FormFieldInfoComponent {}
